// Cookie banner. Choice is stored in localStorage under "copix-consent".
// The Meta Pixel loads on accept
// (window.copixMetaGrant, defined by shared/_meta_pixel).
declare global {
  interface Window {
    copixMetaGrant?: () => void
    copixMetaFlushPending?: () => void
    copixMetaDropPending?: () => void
  }
}

const KEY = 'copix-consent'
const banner = document.querySelector<HTMLElement>('[data-cookie-consent]')

function stored(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

if (banner && !stored()) {
  banner.hidden = false
  banner.addEventListener('click', (event) => {
    const choice = (event.target as HTMLElement).closest<HTMLElement>('[data-consent]')?.dataset.consent
    if (!choice) return
    try {
      localStorage.setItem(KEY, choice)
    } catch {
      // Private mode: the banner shows again next visit.
    }
    if (choice === 'granted') {
      window.copixMetaGrant?.()
      window.copixMetaFlushPending?.()
    } else {
      window.copixMetaDropPending?.()
    }
    banner.hidden = true
  })
}

export {}
